import React from 'react';
import { connect } from 'react-redux';
import { resetRegistration } from '../redux/modules/registration';
import { resetTitleFees } from '../redux/modules/titlefees';
import { resetSales } from '../redux/modules/salestaxes';

const ResetButton = (props) => {
  const which = props.section;

  return (
    <span className="ResetSectionBtn" onClick={() => {
      if (which === 'Registration') {
        props.resetRegistration();
      }
      if (which === 'Title') {
        props.resetTitleFees();
      }
      if (which === 'Sales') {
        props.resetSales();
      }
    }}
    ><i className="fa fa-refresh" aria-hidden="true" /></span>
  );
};

export default connect(null, { resetRegistration, resetTitleFees, resetSales })(ResetButton);



// WEBPACK FOOTER //
// ./src/containers/ResetSection.js